import type { CSSProperties } from 'react';

import { Trans, useTranslation } from 'react-i18next';

import Button from '../../../components/buttons/Button';

import styles from './redeemCashCoachMark.module.scss';

interface RedeemCashCoachMarkProps {
  arrowStyles: CSSProperties;
  popperStyles: CSSProperties;
  setArrowElement: (el: HTMLElement | null) => void;
  setPopperElement: (el: HTMLElement | null) => void;
  onRedeemClick: () => void;
}

export const RedeemCashCoachMark = (props: RedeemCashCoachMarkProps) => {
  const { t } = useTranslation();

  return (
    <div
      ref={props.setPopperElement}
      className={styles.coachMark}
      data-testid="crown-rips-redeem-coachmark"
      style={props.popperStyles}
    >
      <p className={styles.text}>
        {t('crownRips.redeemCoachMark.title')}
        <br />
        <Trans components={{ cash: <span className={styles.cashSign} /> }} i18nKey="crownRips.redeemCoachMark.body" />
      </p>
      <Button
        btnType="main"
        className={styles.cta}
        dataTestId="crown-rips-redeem-coachmark-cta"
        handleOnClick={props.onRedeemClick}
      >
        {t('crownRips.redeemCoachMark.cta')}
      </Button>
      <div ref={props.setArrowElement} className={styles.arrow} style={props.arrowStyles} />
    </div>
  );
};
